const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// react-ga4 is loaded lazily so its bundle stays out of the eager main chunk
// until analytics is actually initialized.
type ReactGAModule = (typeof import('react-ga4'))['default'];
let gaReady: Promise<ReactGAModule> | null = null;

/**
 * Check if Google Analytics is enabled (measurement ID is configured)
 */
export const isAnalyticsEnabled = (): boolean => {
  return !!MEASUREMENT_ID && MEASUREMENT_ID !== 'G-XXXXXXXX';
};

/**
 * Initialize Google Analytics 4
 * Should only be called after user consent
 */
export const initializeAnalytics = (): void => {
  if (!isAnalyticsEnabled()) {
    console.log('Google Analytics is disabled (no measurement ID configured)');
    return;
  }

  if (gaReady) {
    return;
  }

  gaReady = import('react-ga4').then(({ default: ReactGA }) => {
    ReactGA.initialize(MEASUREMENT_ID as string, {
      testMode: process.env.REACT_APP_API_URL?.includes('localhost') || false
    });
    return ReactGA;
  });
};

/**
 * Track a page view
 * @param path - The path of the page (e.g., '/projects', '/billing')
 * @param title - Optional page title
 */
export const trackPageView = (path: string, title?: string): void => {
  if (!isAnalyticsEnabled() || !gaReady) {
    return;
  }

  gaReady.then(ReactGA => {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title
    });
  });
};
